module.exports = "<div id=\"main_header\">\n\n\n  <div id=\"the_name\" [routerLink]=\" ['./home']\">\n  </div>\n\n\n</div>\n\n<main class=\"main_pages\" [@routerTransition]=\"getState(o)\">\n  <router-outlet class=\"outlet\" #o=\"outlet\"></router-outlet>\n</main>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 248
// module chunks = 0